import { motion } from "framer-motion";
import { Clock, Check } from "lucide-react";

interface DurationStepProps {
    selectedDuration: any;
    onSelectDuration: (duration: any) => void;
    startDate: Date;
    DURATIONS: any;
}
const DurationStep = ({
    selectedDuration,
    onSelectDuration,
    DURATIONS
}: DurationStepProps) => {

    type Duration = keyof typeof DURATIONS;

    return (
        <>
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                Elige el horizonte de tu meta
            </h3>
            <div className="grid gap-4">
                {(Object.entries(DURATIONS) as [Duration, typeof DURATIONS.short][]).map(
                    ([key, value]) => (
                        <motion.button
                            key={key}
                            whileHover={{ scale: 1.03 }}
                            whileTap={{ scale: 0.97 }}
                            onClick={() => onSelectDuration(key)}
                            className={`
                flex items-center p-4 rounded-lg border 
                transition-all duration-300 
                ${selectedDuration === key
                                    ? `${value.color} border-opacity-100`
                                    : 'border-gray-200 dark:border-gray-700 border-opacity-50 hover:border-opacity-100'
                                }
              `}
                        >
                            <Clock
                                className={`w-6 h-6 mr-4 ${selectedDuration === key ? 'text-blue-500' : 'text-gray-400'
                                    }`}
                            />
                            <div className="text-left">
                                <div
                                    className={`font-medium ${selectedDuration === key
                                        ? 'text-blue-700 dark:text-blue-400'
                                        : 'text-gray-700 dark:text-gray-300'
                                        }`}
                                >
                                    {value.label}
                                </div>
                                <div className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                    {value.description}
                                </div>
                                <div className="text-xs text-gray-400 mt-1">
                                    {value.months} {value.months === 1 ? 'mes' : 'meses'}
                                </div>
                            </div>
                            {selectedDuration === key && (
                                <Check className="ml-auto w-5 h-5 text-blue-500" />
                            )}
                        </motion.button>
                    )
                )}
            </div>
        </>
    )
};

export default DurationStep;